module.exports = "<p>\n  orders-report works!\n</p>\n"